// @core/ui/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.

// Design tokens
export * from './tokens';

// Utility function for class names
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}
